import React from 'react';
import { Clock, ChefHat } from 'lucide-react';
import recipesData from '../data/recipes.json';

interface Recipe {
  id: number;
  title: string;
  description: string;
  cookingTime: string;
  difficulty: string;
  category: string;
  image: string;
}

const RecipeCard: React.FC<{ recipe: Recipe }> = ({ recipe }) => (
  <div className="bg-white rounded-lg shadow-md overflow-hidden transition-transform hover:scale-105">
    <div className="relative">
      <img 
        src={recipe.image} 
        alt={recipe.title} 
        className="w-full h-48 object-cover"
      />
      <div className="absolute top-4 right-4 bg-white px-3 py-1 rounded-full text-sm font-bold text-custom-green">
        {recipe.category}
      </div>
    </div>
    <div className="p-4">
      <h3 className="text-lg font-bold text-gray-900 mb-2">{recipe.title}</h3>
      <p className="text-gray-600 text-sm mb-4 line-clamp-2">{recipe.description}</p>
      
      <div className="flex items-center justify-between text-sm">
        <div className="flex items-center text-gray-500">
          <Clock className="w-4 h-4 mr-1" />
          <span>{recipe.cookingTime}</span>
        </div>
        <div className="flex items-center text-gray-500">
          <ChefHat className="w-4 h-4 mr-1" />
          <span>{recipe.difficulty}</span>
        </div>
      </div>
    </div>
  </div>
);

const Recipes: React.FC = () => {
  const recipes = recipesData.recipes;

  return (
    <div className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Recipes</h2>
          <p className="text-lg text-gray-600">
            Discover delicious ways to prepare your premium meats
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {recipes.map((recipe) => (
            <RecipeCard key={recipe.id} recipe={recipe} />
          ))}
        </div>

        <div className="mt-12 text-center">
          <button 
            className="bg-white text-custom-green px-8 py-3 rounded-full border-3 border-custom-green hover:bg-gray-50 transition-colors font-bold inline-flex items-center"
          >
            Browse All Recipes
          </button>
        </div>
      </div>
    </div>
  );
};

export default Recipes;